import * as React from 'react';
import PropTypes from 'prop-types';
import { scroller } from 'react-scroll';

import scrollIcon from '../../../images/icons/icon-scroll-down.svg';

import * as styles from './Subtitle.module.scss';


class Subtitle extends React.Component {
  handleScroll = () => {
    scroller.scrollTo('ActiveCountries', {
      duration: 1500,
      smooth: true
    });
  };

  render() {
    const { isScroll, text } = this.props;
    return (
      <section className={styles.root}>
        <div className={styles.container}
             onClick={this.handleScroll}
             style={!isScroll ? { cursor: 'initial' } : null}
        >
          {isScroll && <img alt='Flatfy scroll icon' className={styles.scrollImg} src={scrollIcon}/>}
          <span className={styles.text}>{text}</span>
        </div>
      </section>
    );
  }
}

Subtitle.propTypes = {
  text: PropTypes.string.isRequired,
  isScroll: PropTypes.bool
};

export default Subtitle;
